import { useContext } from 'react';
import Image from '@next/image';

import { FilesContext } from '@providers/FilesProvider';
import Typography from '@components/atoms/Typography';
import ShowMoreContainer from '@components/ShowMoreContainer';
import { FormattedMessage } from 'utils/intl';

import { School } from './SchoolTrustedUs.types';
import classes from './SchoolTrustedUs.module.scss';
import messages from './SchoolTrustedUs.messages';

type Props = {
  schools: School[];
  type: 'high' | 'primary';
};

const SchoolTrustedUs = ({ schools, type }: Props) => {
  const { getPageImageConfigs } = useContext(FilesContext);
  const [high, primary] = getPageImageConfigs(['high-school', 'primary-school']);
  const logo = { high, primary }[type];

  return (
    <ShowMoreContainer
      buttonProps={{
        color: 'secondary',
        variant: 'outlined',
        size: 'md',
      }}
      classes={{
        root: classes.wrapper,
        content: classes.logosContent,
        button: classes.button,
        buttonContent: classes.buttonContent,
      }}
      showMore={(isExpanded) => <FormattedMessage {...(isExpanded ? messages.showLess : messages.showMore)} />}
    >
      <div className={classes.logos}>
        {schools.map(({ id, name, place }) => (
          <div key={id} className={classes.item}>
            {logo && (
              <Image
                alt={`${type}-school`}
                objectFit="contain"
                resolveConfig={logo}
                width={43}
                height={50}
                hasBlendMode={false}
              />
            )}
            <div className={classes.texts}>
              <Typography className={classes.text} variant="label" weight="700">
                {name}
              </Typography>
              <Typography className={classes.text} variant="caption2">
                {place}
              </Typography>
            </div>
          </div>
        ))}
      </div>
    </ShowMoreContainer>
  );
};

export default SchoolTrustedUs;
